export default "Lav jeres egne kreative og smukke fisk til ophæng – lad jer inspirere af laksen fra historien!";